import React, { Component } from 'react';
import {Link}from 'react-router-dom';
import ReactDOM from 'react-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class aeroliftMain extends Component {
  render() {
    var dataNews;
    var dataVideo;
    var builtTmpNews;
    var builtTmpVideos;
    var parseStringNews = require('xml2js').parseString;
    fetch('/newsData.xml')
    .then((r) => r.text())
    .then(text  => {
      parseStringNews(text, function (err, result) {
          dataNews=result;
          var tmpOV = JSON.parse(JSON.stringify(result));
          dataNews= tmpOV.NewsList.News;
          var newDataNews = [];
          for (var ele in dataNews) {
            if (dataNews[ele].Supplier[0].includes("AERO-LIFT")){
              newDataNews.push(dataNews[ele]);
            }
          }
          dataNews = newDataNews;
          builtTmpNews = dataNews.map((element) =>
                <Col xs={12} sm={6} md={4} lg={3} className="newsItem">
                  <div className="newsCont news-supplier">
                    <img src={`../news/${element.Image}`} alt={element.Title} id={`image ${element.Title}`} className={`newsImg${element.classType}`} />
                    <video id="background-video" className={`newsVideo${element.classType}`} loop autoPlay id={`video ${element.Title}`} playsInLine="true">
                        <source src={`../videos/${element.FileShort}`} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    <h4>{element.Title}</h4>
                    <h5>{element.Supplier}</h5>
                    <hr/>
                    <p className="newsText">{element.Text}</p>
                    <hr/>
                    <p className="newsDate">{element.Date}</p>
                  </div>
                </Col>

              );
          }.bind(this));
          this.builtElement = ReactDOM.render(builtTmpNews, document.getElementById('newsRoot'));
      });
    return (
      <div className='container-fluid'>
        <div className="supMain">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/Zubehoer">Zubehör</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>AERO-LIFT</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="Aerolift Vakuumhebetechnik"/>
        </div>
        <div className="supMainText">
          <h1>AERO-LIFT</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={3}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="Aerolift Kranhebeanlage"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="Aerolift gebogenes Blech"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="Aerolift Holz"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={8}>
              <h4>Die AERO-LIFT Vakuumtechnik GmbH gegründet 1992 mit Produktionssitz in Baden Württemberg in Geislingen-Binsdorf ist Hersteller von Vakuumhebern, Vakuumschlauchhebern, Vakuumkomponenten und produziert hochwertige Anlagen und Maschinen der Vakuumhebetechnik und Vakuumtransporttechnik.
In Süddeutschland am Rand der Schwäbischen Alb zwischen Stuttgart und Bodensee gelegen werden Erfolgsressourcen konsequent genutzt. Mit viel Innovationskraft und in einem angenehmen Arbeitsumfeld werden hochwertige Vakuumheber, Vakuumschlauchheber und Vakuumkomponenten gefertigt. Mit großer Flexibilität und Innovationskraft und mit motivierten, fachkompetenten Mitarbeitern kann in vielen Einsatzgebieten eine vakuumtechnische Lösung gefunden werden. Eine große Fertigungstiefe im eigenen Hause ist dem Hersteller aus der Vakuumtechnik wichtig, um auf individuelle Kundenanfragen reagieren zu können.</h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>Die AERO-LIFT Vakuumtechnik GmbH gegründet 1992 mit Produktionssitz in Baden Württemberg in Geislingen-Binsdorf ist Hersteller von Vakuumhebern, Vakuumschlauchhebern, Vakuumkomponenten und produziert hochwertige Anlagen und Maschinen der Vakuumhebetechnik und Vakuumtransporttechnik.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="https://www.aero-lift.de/" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
        <br/>
      </div>

        <section>
          <Grid className="gridUp">
            <br/>
            <center>
            <h1>Produkte</h1>
            </center>
            <br/><br/>
            <Row className="show-grid">
              <Col  xs={12} sm={6}>
                <center>
                  <div className="productsButton">
                    <Link to="/Suppliers/Aerolift/Vakuumheber"><h4 className="buttonBlue">Vakuumheber & Vakuumhebegeräte</h4>
                      <h5>Egal ob Blech, Holz oder Glas - mit den AERO-LIFT Vakuumhebegeräten lässt sich nahezu jedes luftundurchlässige Transportgut bewegen, drehen und wenden. Alle AERO-LIFT-Vakuumheber haben eine nach EN13155 vorgeschriebene automatisch wirkende Warneinrichtung mit akustischer oder zusätzlich optischer Signalisierung. Diese sorgt für hohe Sicherheit im Arbeitsprozess und schützt Mitarbeiter sowie Transportgut.</h5>
                      <p>Mehr ...</p>
                    </Link>
                  </div>
              </center>
              </Col>
              <Col  xs={12} sm={6}>
                <center>
                  <div className="productsButton">
                    <Link to="/Suppliers/Aerolift/Baustellengeraete"><h4 className="buttonBlue">Baustellengeräte</h4>
                  <h5>Ob praktischer Baustellenhelfer oder prozesssichere Handhabungslösung - in fast allen Bereichen der Bauwirtschaft unterstützen wir mit schnellen, effizienten und sicheren Systemen. Durch Vakuumheber für die Baustelle wird der Transport von schweren oder extrem unhandlichen Bauteilen und Materialien nahezu spielend leicht.</h5>
                <p>Mehr ...</p>
              </Link>
              </div>
              </center>
              </Col>
            </Row>
            <Row className="show-grid">
              <Col  xs={12} sm={6}>
                <center>
                  <div className="productsButton">
                    <Link to="/Suppliers/Aerolift/Schlauchheber"><h4 className="buttonBlue">Schlauchheber</h4>
                      <h5>Einfaches Handling von Kartonagen, Papier- und Kunststoffsäcken, sowie Eimern und Fässern. In vielen Einsatzbereichen wie dem Handling von Kartons im Versand, dem Abstapeln von Säcken in der Pharmaindustrie oder dem Transportieren von Eimern, Kanistern und Fässern in der chemischen Industrie entlastet der Schlauchheber die Mitarbeiter. </h5>
                      <p>Mehr ...</p>
                    </Link>
                  </div>
              </center>
              </Col>
              <Col  xs={12} sm={6}>
                <center>
                  <div className="productsButton">
                    <Link to="/Suppliers/Aerolift/Automation"><h4 className="buttonBlue">Robotic & Automation</h4>
                  <h5>AERO-LIFT bietet die komplette Vakuumtechnik oder auch nur Komponenten für die Automation. Sowohl im Maschinenbau als auch in der Roboterindustrie (Verpackungsmaschinen, Automobilbau, Pharmaindustrie um nur einige zu nennen) können Vakuum-Elemente zum Aufbau eigener Vakuum-Systeme eingesetzt werden. Schnelle Taktzahlen und verschleißarme Komponenten wie z.B. bei VUSS Ventilen sorgen für eine effiziente Automatisierung der Prozesse - ganz ohne Umrüstzeiten.</h5>
                <p>Mehr ...</p>
              </Link>
              </div>
              </center>
              </Col>
            </Row>
          </Grid>
            <br/>
        </section>
        <section>
          <br/>
          <center>
          <h1>News</h1>
          </center>
          <br/><br/>
          <center>
          <div className="newsAtSupplier" id="newsRoot"/>
          </center>
          <br/><br/><br/>
        </section>
        </div>
    );
  }
}

export default aeroliftMain;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/aerolift/mainPageSup.js